<template lang="pug">
  #MemberSearchIndex
    .content-header.bg-secondary.rounded-bottom-1rem.d-flex.align-items-center.justify-content-between
      h5.mb-0 標籤會員篩選
      .position-relative
        b-button.font-weight-bold.btn-custom(
          variant="primary",
          @click="selectUserhHandler(true)",
          style="border-radius: 50px;padding: 0px 15px;border: 4px solid #FFF;box-shadow: 0.2rem 0.2rem 0 #00000033;",
          v-if="!selectMode"
        ) 選取顧客
        b-button.font-weight-bold.btn-custom(
          variant="primary",
          @click="selectAll()",
          style="border-radius: 50px;padding: 0px 15px;border: 4px solid #FFF;box-shadow: 0.2rem 0.2rem 0 #00000033;",
          v-if="selectMode"
        ) {{ selectUsers.length > 0 ? '取消全選' : '全選'}}
    .container-width(
      :class="{ 'pb-50': selectMode }"
    )
      .p-3
        b-card.border-0.mb-2.customerCard.overflow-hidden(
          bg-variant="white",
          v-for="(user,index) in memberList",
          :key="user.member_id",
          @click="showUserInfoHandler(user.member_id)",
          body-class="p-0",
          v-if="memberList && memberList.length > 0"
        )
          .row.p-3.outline-invitation(
            :class="{ 'member': index !== 0 }"
          )
            .align-items-center.justify-content-center(
              v-show="selectMode"
            )
              input.invitation_checker(
                type="checkbox",
                :id="`checkbox-group-${index}`",
                :name="`user-${index}`",
                :value="user",
                v-model="selectUsers",
                :checked="isChecked(index)"
                v-show="selectMode"
              )
              .input_wrap.h-100.d-flex.align-items-center
                .invitation-icon.border-black.mr-2(@click="selectMemberHandler(user.member_id)")
            div(
              :class="{ 'col-10': selectMode, 'col-12': !selectMode }"
            )
              label.w-100.mb-0(
                :for="`checkbox-group-${index}`"
              )
                .row.align-items-center.no-gutters(
                  :class="{ 'border-bottom border-black': index + 1 !== memberList.length }"
                )
                  .col-3.pr-1
                    ProfilePhotoSticker.ProfilePhotoSticker.d-flex.align-items-center.justify-content-center.border.border-black(
                      :profileUrl="user.picture_url",
                      :style="{ 'width': '60px', 'height': '60px' }"
                    )
                  .col-9.pl-1
                    p.mb-0.font-weight-bold {{ user.line_display_name }}
                    p.mb-0.text-gray {{ user.note_name ? user.note_name : '-' }}
        h5.text-center(
          v-if="!memberList || memberList.length === 0"
        ) 無搜尋結果
      .d-flex.w-100.bg-black.position-fixed.align-items-center.justify-content-center(
        style="bottom: 0;bottom: 50px;height: 60px;z-index: 3;",
        v-if="selectMode"
      )
        b-badge.rounded-50.d-flex.align-items-center.justify-content-center.button.button-people.iconBtn.iconPushBtn.p-1.position-absolute(
          pill,
          variant="danger",
          style="right: 0px;top: 0px;"
        )
          span {{ filterMoney(selectUsers.length) }}
        b-button.font-weight-bold.mr-2.btn-custom(
          variant="primary",
          block,
          @click="selectUserhHandler(false)",
          style="height: 60%;border: 0.4rem solid #fff;border-radius: 50px;padding: 0px 15px;border: 4px solid #FFF;box-shadow: 0.2rem 0.2rem 0 #00000033;"
        ) 取消選取
        b-button.font-weight-bold.mt-0.btn-custom(
          variant="primary",
          block,
          @click="selectUserhHandler(true)",
          style="height: 60%;border: 0.4rem solid #fff;border-radius: 50px;padding: 0px 15px;border: 4px solid #FFF;box-shadow: 0.2rem 0.2rem 0 #00000033;"
        ) 確認選取
</template>

<script>
import { mapState } from 'vuex';
import ProfilePhotoSticker from '@/components/profilePhotoSticker/ProfilePhotoStickerComponent.vue';
import { SA_GROUP_PUSH_INDEX } from '@/router/sa/group-push';
import { SA_MY_CUSTOMER_INDEX } from '@/router/sa/my-customer';

export default {
  name: 'MemberSearchShow',
  components: {
    ProfilePhotoSticker
  },
  data() {
    return {
      selectMode: false,
      selectUsers: [],
    };
  },
  methods: {
    selectUserhHandler(mode) {
      const vm = this;
      // 如果是點推播按鈕且目前在選擇使用者模式
      if (mode && vm.selectMode && vm.selectUsers && vm.selectUsers.length > 0) {
        vm.$store.commit('sa_group_push/setMemberList', vm.selectUsers);
        vm.$router.push({
          name: SA_GROUP_PUSH_INDEX
        });
      } else {
        vm.selectUsers = [];
        vm.selectMode = mode;
      }
    },
    showUserInfoHandler(userId) {
      const vm = this;
      if (vm.selectMode) return;
      vm.$router.push({
        name: SA_MY_CUSTOMER_INDEX,
        params: {
          userId
        }
      }).catch(() => {});
    },
    selectAll() {
      const vm = this;
      if (vm.selectUsers.length === 0 || !vm.selectUsers) {
        vm.$set(vm, 'selectUsers', vm.memberList);
      } else {
        vm.$set(vm, 'selectUsers', []);
      }
    },
    // 選擇發送對象
    selectMemberHandler(id ) {
      const vm = this;
      const selectMembers_key = _.findKey(vm.selectUsers, (val) => val.member_id === id);
      if (selectMembers_key) {
        vm.selectUsers.splice(selectMembers_key, 1);
      } else {
        const members_key = _.findKey(vm.memberList, (val) => val.member_id === id);
        if (members_key) {
          vm.selectUsers.push(vm.memberList[members_key]);
        }
      }
    },
    isChecked(index) {
      const vm = this;
      const key = _.findKey(vm.selectUsers, (val) => val.member_id === vm.memberList[index].member_id);
      if (key) {
        return true;
      }
      return false;
    }
  },
  computed: {
    ...mapState({
      memberList: (state) => state.sa_label.memberShowList
    })
  }
};
</script>

<style lang="scss" scoped>
.searchArea {
  &__iconArrow {
    position: absolute;
    right: 10px;
    top: 5px;
    outline: none;
    transform: rotate(0deg);
    transition: all .3s;
  }
  &__iconArrow.collapsed {
    transform: rotate(180deg);
  }
}

.ProfilePhotoSticker {
  border: 0.2rem solid #000!important;
}

.pb-50 {
  padding-bottom: 50px;
}

.border-black{
  border: 0.2rem solid #000;
}

.custom-shadow {
  -webkit-box-shadow: 0.2rem 0.2rem 0 #00000033;
  box-shadow: 0.2rem 0.2rem 0 #00000033;
}

.invitation-icon {
  width: 2rem;
  height: 2rem;
  background-color: #fff;
  border-radius: 0.4rem;
  margin-right: 1.2rem;
  position: relative;
}

.invitation_checker:checked ~ .input_wrap .invitation-icon {
  background-color: #ef4852;
}

.invitation_checker:checked ~ .input_wrap .invitation-icon::after {
  display: block;
}

.invitation-icon::after {
  content: '';
  display: none;
  position: absolute;
  top: 50%;
  left: 50%;
  -webkit-transform: translate(-50%, -50%);
  transform: translate(-50%, -50%);
  width: 1.5rem;
  height: 1rem;
  background-image: url(../../../assets/images/icon/check-1.png);
  background-size: 1.5rem;
  background-repeat: no-repeat;
}

input[type="checkbox"], input[type="radio"] {
  position: absolute;
  width: 1px;
  height: 1px;
  display: none;
  opacity: 0;
}

.member {
  border-top: 1px solid #969696;
}
</style>
